/* ============================================================================
 * Meadow & Bark — Giveaway thank-you page (§7.1)
 * Reads the stored ambassador slug, looks up their UpPromote tracking link in
 * the registry, and points the Shop button at it (sets the sca_ref sale cookie
 * on click → enables link attribution / Scenario 2). Degrades to the plain
 * store URL if the slug is missing or unknown.
 * ==========================================================================*/
(function () {
  'use strict';

  var STORE_URL = 'https://www.meadowandbark.com';
  // Static prototype path; on Shopify use: {{ 'ambassadors.json' | asset_url }}
  var REGISTRY_URL = 'assets/data/ambassadors.json';

  function getAmbassador() {
    if (typeof window.MB_getAmbassador === 'function') return window.MB_getAmbassador();
    try {
      var v = localStorage.getItem('mb_amb');
      if (v) return v;
    } catch (e) {}
    var m = document.cookie.match(/(?:^|;\s*)mb_amb=([^;]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    var shopBtn = document.querySelector('[data-shop-link]');
    if (!shopBtn) return;

    // Shopify: registry/store URLs injected via data-* (falls back to defaults).
    var registryUrl = shopBtn.dataset.registry || REGISTRY_URL;
    var storeUrl = shopBtn.dataset.storeUrl || STORE_URL;

    var slug = (getAmbassador() || '').toLowerCase().trim();

    // Fallback first, so the button always works even if the fetch fails.
    shopBtn.href = storeUrl;

    if (!slug) return;

    fetch(registryUrl)
      .then(function (r) { return r.json(); })
      .then(function (registry) {
        var amb = registry[slug];
        if (amb && amb.sca_ref) {
          // Build the link from ONE base + the ambassador's sca_ref token, so
          // the store domain/destination lives in a single place (data-store-url).
          shopBtn.href = storeUrl + (storeUrl.indexOf('?') > -1 ? '&' : '?') +
            'sca_ref=' + amb.sca_ref;
        }
      })
      .catch(function (e) { console.error('[thank-you] registry load failed:', e); });
  });
})();
